import { useEffect, useState } from "react";
import { useApplicationContext } from "../context/applicationContext";

import { RoleId } from "../../../shared/enums/Role";
import AuthorisedRepresentativeManagementComponent from "../../authorisedRepresentativeManagement/AuthorisedRepresentativeManagementComponent";
import { useGlobalContext } from "../../../shared/GlobalContext";
import { useApiClient } from "../../../shared/customHooks";
import { UserLinksDiscriminator } from "../../../shared/enums/LinkDiscriminator";
import { AuthorisationLevel } from "../../../shared/enums/AuthorisationLevel";

function AuthorisedRepresentativeComponent() {
  const [users, setUsers] = useState<any[]>([]);
  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const {
    application: { hasAppeal },
    id,
  } = useApplicationContext();
  const {
    addNavItem,
    accountInfo: { isManager },
  } = useGlobalContext();

  useEffect(() => {
    addNavItem({
      label: "Authorised Representative Management",
      id: "AuthorisedRepresentativeManagement",
    });
    fetchData(`getInvitedUsers/${id}`, { discriminator: 0 }).then((res: any) => {
      setUsers(res.data);
    });
  }, []);

  return (
    <>
      <div className="flex flex-column align-items-start w-full p-5 pl-container" id="AuthorisedRepresentativeManagement">
        <AuthorisedRepresentativeManagementComponent
          id={id}
          otherValues={{
            roleType: RoleId.Kindergarten,
            userLinkDiscriminator: UserLinksDiscriminator.application,
            authorisationLevel: AuthorisationLevel.AuthorisedRepresentative,
          }}
          data={users}
          showInvite={!hasAppeal && isManager}
          tooltipText="Invite User to Application"
          label="Invite a user to join the KIS Application"
          advisory=""
        />
      </div>
    </>
  );
}

export default AuthorisedRepresentativeComponent;
